import React, { Component } from 'react';
import { Container, Loader } from 'semantic-ui-react';
import { isNullOrUndefined } from 'util';
import _ from 'lodash';

import { getAds } from '../../fbApi/Ad';
import TabContainerComponent from './ParentSection/TabContainerComponent';
import { getCampaign } from '../../fbApi/Campaign';
import { buildAdPreviewObjectCompare, sortAdsByFormat } from '../../utils/ad.common';
import { retrieveAllAdsInfo } from '../../services/AdServiceManager';
import './UpdateFlipperAds.css';

class UpdateFlipperAds extends Component {
  state = {
    processing: false,
    message: '',
    tabs: [],
    showTabs: false,
    campaignName: {
      PRODUCT_CATALOG_SALES: null,
      LEAD_GENERATION: null,
      VIDEO_VIEWS: null,
      LINK_CLICKS: null,
      CONVERSIONS: null,
      OUTCOME_TRAFFIC: null,
      OUTCOME_SALES: null
    },
    campaignMonth: {
      PRODUCT_CATALOG_SALES: [],
      LEAD_GENERATION: [],
      VIDEO_VIEWS: [],
      LINK_CLICKS: [],
      CONVERSIONS: [],
      OUTCOME_TRAFFIC: [],
      OUTCOME_SALES: []
    },
    token: this.props.getFbToken(),
  };
  componentDidMount() {
    this.props.setSectionTitle('Update Flipper Ads');
    this.getAdsToCompare();
  }

  getAds = async (ids, selection) => {
    this.setState({
      showAdsLoading: true,
    });

    const allCampaigns = await Promise.all(
      _.map(ids, async (camp) => {
        const campaign = await getCampaign(camp, this.state.token);

        const campaignObjective = campaign.objective;
        const cn = this.state.campaignName;
        cn[campaignObjective] = campaign.name.replace(/_/g, ' ');
        this.setState({
          campaignName: cn,
        });
        const resultAds = await getAds(campaign.id, this.state.token);
        const ads = resultAds.data;

        const previewObjects = ads.map(async ad => ({ ...ad, campaignObjective }));
        // const previewObjects = ads.map(async ad => (buildAdPreviewObjectCompare(ad, selection, this.state.token)));
        return Promise.all(previewObjects);
      })
    );

    const ccm = {
      PRODUCT_CATALOG_SALES: [],
      LEAD_GENERATION: [],
      VIDEO_VIEWS: [],
      LINK_CLICKS: [],
      CONVERSIONS: [],
      OUTCOME_TRAFFIC: [],
      OUTCOME_SALES: []
    };
    _.forEach(allCampaigns, (c) => {
      if (c[0] && ccm[c[0].campaignObjective]) {
        ccm[c[0].campaignObjective] = ccm[c[0].campaignObjective].concat(c);
      }
    });

    const allIds = [];
    Object.keys(ccm).forEach((o) => {
      ccm[o].forEach(ad => allIds.push(ad.id));
    });
    const allAdsInfo = await retrieveAllAdsInfo(allIds.join(','));

    this.setState({
      [`adsToCompare${selection}`]: ccm,
      [`allAdsInfo${selection}`]: allAdsInfo,
    });
  };

  getAdsToCompare = async () => {
    this.setState({
      processing: true,
      message: 'Comparing...',
      showTabs: false,
      processTabs: false,
    });
    const idsFirst = this.props.location.state.campaignsToCompare.sourceAds.map(a => a.campaignId);
    const idsSecond = this.props.location.state.campaignsToCompare.targetAds.map(a => a.campaignId);
    await this.getAds([...(new Set(idsFirst))], 'First');
    await this.getAds([...(new Set(idsSecond))], 'Second');
    this.setState({
      processTabs: true,
    });
  };

  filterAds = adsToFilter => (
    adsToFilter.filter(a => !isNullOrUndefined(a.lineageInfo) &&
      (isNullOrUndefined(a.lineageInfo.parentCategory) ||
      isNullOrUndefined(a.lineageInfo.parentPackage) ||
      isNullOrUndefined(a.lineageInfo.parentLanguage) ||
      isNullOrUndefined(a.lineageInfo.parentGroup) ||
      isNullOrUndefined(a.lineageInfo.oemFocus) ||
      isNullOrUndefined(a.lineageInfo.parentEvent)))
  )

  processAdsAsync = async (compareAdsFirst, compareAdsSecond) => {
    const firstAds = await Promise.all(_.map(compareAdsFirst, async (ad) => {
      const adData = this.state.allAdsInfoFirst.ads.find(a => a.adId === ad.id);
      const buildAd = {
        ...ad,
        adData: adData ? adData.adData : undefined,
      };
      const adPreview = await buildAdPreviewObjectCompare(buildAd, 'First', this.state.token);
      return adPreview;
    }));
    const secondAds = await Promise.all(_.map(compareAdsSecond, async (ad) => {
      const adData = this.state.allAdsInfoSecond.ads.find(a => a.adId === ad.id);
      const buildAd = {
        ...ad,
        adData: adData ? adData.adData : undefined,
      };
      const adPreview = await buildAdPreviewObjectCompare(buildAd, 'Second', this.state.token);
      return adPreview;
    }));
    return {
      firstAds,
      secondAds,
    };
  }
  initializeTabs = async () => {
    const tabs = [];
    if (this.state.adsToCompareFirst.LINK_CLICKS.length > 0 || this.state.adsToCompareSecond.LINK_CLICKS.length > 0) {
      const processedAds = await this.processAdsAsync(this.state.adsToCompareFirst.LINK_CLICKS, this.state.adsToCompareSecond.LINK_CLICKS);
      const ads = sortAdsByFormat(processedAds.firstAds, processedAds.secondAds, this.state);
      ads.sortedAdsFirst = this.filterAds(ads.sortedAdsFirst);
      ads.sortedAdsSecond = this.filterAds(ads.sortedAdsSecond);
      tabs.push({
        menuItem: 'Traffic Ads',
        ads,
        tabKey: 'LINK_CLICKS',
      });
    }

    if (this.state.adsToCompareFirst.LEAD_GENERATION.length > 0 || this.state.adsToCompareSecond.LEAD_GENERATION.length > 0) {
      const processedAds = await this.processAdsAsync(this.state.adsToCompareFirst.LEAD_GENERATION, this.state.adsToCompareSecond.LEAD_GENERATION);
      const ads = sortAdsByFormat(processedAds.firstAds, processedAds.secondAds, this.state);
      ads.sortedAdsFirst = this.filterAds(ads.sortedAdsFirst);
      ads.sortedAdsSecond = this.filterAds(ads.sortedAdsSecond);
      tabs.push({
        menuItem: 'Lead Ads',
        ads,
        tabKey: 'LEAD_GENERATION',
      });
    }

    if (this.state.adsToCompareFirst.VIDEO_VIEWS.length > 0 || this.state.adsToCompareSecond.VIDEO_VIEWS.length > 0) {
      const processedAds = await this.processAdsAsync(this.state.adsToCompareFirst.VIDEO_VIEWS, this.state.adsToCompareSecond.VIDEO_VIEWS);
      const ads = sortAdsByFormat(processedAds.firstAds, processedAds.secondAds, this.state);
      ads.sortedAdsFirst = this.filterAds(ads.sortedAdsFirst);
      ads.sortedAdsSecond = this.filterAds(ads.sortedAdsSecond);
      tabs.push({
        menuItem: 'Video Ads',
        ads,
        tabKey: 'VIDEO_VIEWS',
      });
    }

    if (this.state.adsToCompareFirst.PRODUCT_CATALOG_SALES.length > 0 || this.state.adsToCompareSecond.PRODUCT_CATALOG_SALES.length > 0) {
      const processedAds = await this.processAdsAsync(this.state.adsToCompareFirst.PRODUCT_CATALOG_SALES, this.state.adsToCompareSecond.PRODUCT_CATALOG_SALES);
      const ads = sortAdsByFormat(processedAds.firstAds, processedAds.secondAds, this.state);
      ads.sortedAdsFirst = this.filterAds(ads.sortedAdsFirst);
      ads.sortedAdsSecond = this.filterAds(ads.sortedAdsSecond);
      tabs.push({
        menuItem: 'Dynamic Ads',
        ads,
        tabKey: 'PRODUCT_CATALOG_SALES',
      });
    }

    if (this.state.adsToCompareFirst.CONVERSIONS.length > 0 || this.state.adsToCompareSecond.CONVERSIONS.length > 0) {
      const processedAds = await this.processAdsAsync(this.state.adsToCompareFirst.CONVERSIONS, this.state.adsToCompareSecond.CONVERSIONS);
      const ads = sortAdsByFormat(processedAds.firstAds, processedAds.secondAds, this.state);
      ads.sortedAdsFirst = this.filterAds(ads.sortedAdsFirst);
      ads.sortedAdsSecond = this.filterAds(ads.sortedAdsSecond);
      tabs.push({
        menuItem: 'Engagement Ads',
        ads,
        tabKey: 'CONVERSIONS',
      });
    }

    this.setState({
      tabs,
      processing: false,
      message: '',
      showTabs: true,
    });
  };

  renderTabs = () => {
    if (this.state.showTabs && this.state.tabs && this.state.adsToCompareFirst && this.state.adsToCompareSecond) {
      return (
        <div>
          <TabContainerComponent flipping tabs={this.state.tabs} getFbToken={this.props.getFbToken} />
        </div>
      );
    }
    return (
      <Container>
        <Loader inline className="active" />
      </Container>
    );
  }

  render() {
    if (this.state.processTabs && !this.state.showTabs) {
      this.initializeTabs();
    }
    return (
      <div className="page-container">
        <div className="container">
          {this.renderTabs()}
        </div>
      </div>
    );
  }
}

export default UpdateFlipperAds;



// WEBPACK FOOTER //
// ./src/screens/Flipper/UpdateFlipperAds.js